import ClienteService from "@/services/ClienteService";
import {
    VuexModule,
    Module, Action
} from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
class Cliente extends VuexModule {

    @Action
    async buscarSituacaoFinanc(): Promise<boolean> {
        return ClienteService.buscarSitFinanc().then(
            resp => {
                if (resp.data && resp.data.trim() == 'L')
                    return Promise.resolve(true);

                store.dispatch(
                    "Notifications/showErrorMessage",
                    "Sua situação financeira não permite a criação de novos pedidos.",
                    { root: true }
                );
                return Promise.resolve(false);
            },
            err => {
                const message = err.response.data;
                store.dispatch(
                    "Notifications/showErrorMessage",
                    "Falha ao consultar situação financeira: " + message,
                    { root: true }
                );
                return Promise.resolve(false);
            }
        );
    }
}

export default Cliente;
